import { render, staticRenderFns } from "./SettingsWhatsApp.vue?vue&type=template&id=06240fa9&"
import script from "./SettingsWhatsApp.vue?vue&type=script&lang=js&"
export * from "./SettingsWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports